import {tableActions} from "./members";

var sections = function () {
    let elements = $('.sections-members');

    if(elements.length){
        for(let i=0; i < elements.length; i++){
            let element = $(elements[i]);

            // Get first item and insert content to the main table
            // let firstTabHTML = $( element.find('.tab-item')[0]);
            //
            // element.find('.additional-info').html(firstTabHTML.html())
            tableActions(element, false, 1);
        }
    }
}

export default sections;


// WEBPACK FOOTER //
// ./resources/assets/js/functions/sections.js